module.exports = __webpack_public_path__ + "img/yanniksimon.91e7a58b.png";